import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const estatus = `${baseUrl}/estatus`;

export const allEstatusService = async () => {
  const res = await axios.get(estatus, {
    headers: token({}),
  });
  return res;
};
